import { render, staticRenderFns } from "./RarityIcon.vue?vue&type=template&id=9bb1a99a&scoped=true"
import script from "./RarityIcon.vue?vue&type=script&lang=js"
export * from "./RarityIcon.vue?vue&type=script&lang=js"
import style0 from "./RarityIcon.vue?vue&type=style&index=0&id=9bb1a99a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_cy24jmswklxzc46cxvuobxvpsa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb1a99a",
  null
  
)

export default component.exports